"use client";

import { useEffect } from "react";

import { useLearning } from "@/context/NutrafolAcademyContext";
import { MODAL_VIEWS } from "@/types/nutrafolAcademy";

import CourseModalShell from "./CourseModalShell";
import CourseVideo from "./CourseVideo";
import EnterEmail from "./EnterEmail";
import LearningComplete from "./LearningComplete";
import ProductQuiz from "./ProductQuiz";

const CourseModal = () => {
  const { isModalOpen, closeModal, modalView } = useLearning();
  const isEmailView = modalView === MODAL_VIEWS.EMAIL;

  useEffect(() => {
    if (modalView !== MODAL_VIEWS.DONE) return;
    const timer = setTimeout(() => closeModal(), 10000);
    return () => clearTimeout(timer);
  }, [modalView, closeModal]);

  if (!isModalOpen) return null;

  return (
    <CourseModalShell
      closeModal={closeModal}
      dismissible={!isEmailView}
      showCloseOnDesktop={modalView === MODAL_VIEWS.DONE}
    >
      {modalView === MODAL_VIEWS.QUIZ ? <ProductQuiz /> : null}
      {modalView === MODAL_VIEWS.VIDEO ? <CourseVideo /> : null}
      {modalView === MODAL_VIEWS.EMAIL ? <EnterEmail /> : null}
      {modalView === MODAL_VIEWS.DONE ? <LearningComplete /> : null}
    </CourseModalShell>
  );
};

export default CourseModal;
